// extracted by mini-css-extract-plugin
export default {"vigContainer":"VIG_vigContainer__BruRo","icon":"VIG_icon__4sU-E","container":"VIG_container__CBe7W","image":"VIG_image__qVRVs","circle":"VIG_circle__DzNEi"};